import { PublicClientApplication, AuthenticationResult } from "@azure/msal-browser";
// import { Buffer } from 'buffer';

export class AuthService {
  private pca: PublicClientApplication;
  private codeVerifier: string;
  private redirectUri: string;

  constructor() {
    console.log("AuthService: Initializing");
    
    // this.redirectUri = `${window.location.origin}/dialog.html`;
    // console.log("AuthService: Using redirect URI:", this.redirectUri);

    this.pca = new PublicClientApplication({
      auth: {
       
        // clientId: '15d1c828-ab95-4c0a-b32a-97e7b4d5c4a7', //megazap
         clientId: '29306677-1fc4-4b34-8e3b-eff5577dcfdb', //Cubic Logics
        authority: 'https://login.microsoftonline.com/common',
        redirectUri: "https://clm365outlookaddins.azurewebsites.net/dialog.html",
        postLogoutRedirectUri: window.location.origin,
        navigateToLoginRequestUrl: false
      },
      cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: true
      },
      system: {
        loggerOptions: {
          loggerCallback: (level, message, containsPii) => {
            if (!containsPii) {
              console.log(`MSAL (${level}): ${message}`);
            }
          },
          piiLoggingEnabled: false,
          logLevel: 3
        }
      }
    });
    this.codeVerifier = this.generateCodeVerifier();
  }

  private generateCodeVerifier(): string {
    try {
      const array = new Uint8Array(32);
      crypto.getRandomValues(array);
      return this.base64URLEncode(array);
    } catch (error) {
      console.error("AuthService: Error generating code verifier:", error);
      throw error;
    }
  }

  private async generateCodeChallenge(verifier: string): Promise<string> {
    try {
      const encoder = new TextEncoder();
      const data = encoder.encode(verifier);
      const hash = await crypto.subtle.digest('SHA-256', data);
      return this.base64URLEncode(new Uint8Array(hash));
    } catch (error) {
      console.error("AuthService: Error generating code challenge:", error);
      throw error;
    }
  }

  private base64URLEncode(buffer: Uint8Array): string {
    try {
      const base64 = btoa(Array.from(buffer).map(byte => String.fromCharCode(byte)).join(''));
      return base64
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=+$/, '');
    } catch (error) {
      console.error("AuthService: Error in base64URLEncode:", error);
      throw error;
    }
  }

  async initialize(): Promise<void> {
    try {
      console.log("AuthService: Starting initialization");
      await this.pca.initialize();
      console.log("AuthService: Initialization complete");
    } catch (error) {
      console.error("AuthService: Initialization failed:", error);
      throw error;
    }
  }

  //popup every Time
  // async login(): Promise<AuthenticationResult> {
  //   try {
  //     console.log("AuthService: Initiating login with popup");
  //     const loginRequest = {
  //      scopes: [`https://megazap.sharepoint.com/Sites.FullControl.All`],//change the tenant
  //     };

  //     const response = await this.pca.loginPopup(loginRequest);
  //     console.log("AuthService: Login successful", response);
  //     return response;
  //   } catch (error) {
  //     console.error("AuthService: Error during login:", error);
  //     throw error;
  //   }
  // }

  //Popup One Time
  async login(): Promise<AuthenticationResult> {
    try {
      console.log("AuthService: Attempting silent token acquisition");
      const accounts = this.pca.getAllAccounts();
     const tenantURL=localStorage.getItem("TenantURL");
      if (accounts.length > 0) {
        // Try silent token acquisition first
        try {
          const silentRequest = {
            scopes: [`${tenantURL}/Sites.FullControl.All`],
            account: accounts[0]
          };
         
          const silentResult = await this.pca.acquireTokenSilent(silentRequest);
          console.log("AuthService: Silent token acquisition successful");
          return silentResult;
        } catch (silentError) {
          console.log("AuthService: Silent token acquisition failed, falling back to popup", silentError);
        }
      }
 
      // If silent acquisition fails or no account exists, fall back to popup
      console.log("AuthService: Initiating login with popup");
      const loginRequest = {
        scopes: [`${tenantURL}/Sites.FullControl.All`],
        
      };
 
      const response = await this.pca.loginPopup(loginRequest);
      console.log("AuthService: Login successful", response);
      return response;
    } catch (error) {
      console.error("AuthService: Error during login:", error);
      throw error;
    }
  }

  async getToken(): Promise<string | null> {
    try {
      console.log("AuthService: Getting token");
      const account = this.pca.getAllAccounts()[0];
      if (!account) {
        console.log("AuthService: No account found");
        return null;
      }

      const response = await this.pca.acquireTokenSilent({
        scopes: ['Sites.Read.All', 'User.Read'],

        account: account
      });

      console.log("AuthService: Token retrieved successfully");
      return response.accessToken;
    } catch (error) {
      console.error("AuthService: Error getting token:", error);
      return null;
    }
  }
} 